module.exports = __webpack_public_path__ + "static/lightning-table-edit-highlight-d166c258a8ea1649989833be52d69baa.png";